// Live branding preview — shows how the org's logo/details will look on their
// notice documents and outgoing emails, driven by the UNSAVED Settings form.
import { useState } from "react";
import { FileText, Mail } from "lucide-react";

const DEFAULT_BRAND = "Pool & Spa Certification";

export const BrandingPreview = ({ form, email }) => {
  const [tab, setTab] = useState("notice");
  const custom = !!form.business_logo;
  const brandName = custom ? (form.company_name || "Your Business") : DEFAULT_BRAND;

  return (
    <div>
      <div className="flex items-center gap-2 mb-2">
        <p className="text-xs font-bold uppercase tracking-wider text-slate-600 flex-1">Live preview</p>
        <button type="button" data-testid="preview-tab-notice" onClick={() => setTab("notice")}
          className={`h-8 px-3 inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider rounded-full border ${
            tab === "notice" ? "bg-slate-900 text-white border-slate-900" : "border-slate-300 text-slate-500 hover:text-slate-800"}`}>
          <FileText size={12} /> Notice
        </button>
        <button type="button" data-testid="preview-tab-email" onClick={() => setTab("email")}
          className={`h-8 px-3 inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider rounded-full border ${
            tab === "email" ? "bg-slate-900 text-white border-slate-900" : "border-slate-300 text-slate-500 hover:text-slate-800"}`}>
          <Mail size={12} /> Email
        </button>
      </div>

      {tab === "notice" ? (
        <div className="light-island rounded-lg border-2 border-slate-200 p-5 shadow-inner" data-testid="branding-preview-notice">
          {/* document header */}
          <div className="flex items-center gap-3 pb-3 border-b-2" style={{ borderColor: "#14B8A6" }}>
            {custom ? (
              <img src={form.business_logo} alt="" className="h-12 max-w-[140px] object-contain" />
            ) : (
              <div className="h-12 w-12 rounded bg-[#1E1B4B] text-white flex items-center justify-center font-black text-lg" style={{ backgroundColor: "#1E1B4B", color: "#fff" }}>P</div>
            )}
            <div>
              <p className="font-black text-sm" style={{ color: "#1E1B4B" }}>{brandName}</p>
              {!custom && <p className="text-[11px] italic" style={{ color: "#0F766E" }}>Your safety is our priority</p>}
            </div>
            <p className="ml-auto text-[10px] text-slate-400 text-right">12 Sample Street<br />Sydney NSW 2000</p>
          </div>
          <p className="mt-4 text-center font-black text-sm" style={{ color: "#1E1B4B" }}>NOTICE OF NON-COMPLIANT SWIMMING POOL</p>
          <p className="text-center text-[10px] text-slate-500 mt-0.5">Swimming Pools Act 1992 (NSW) · AS1926.1-2012</p>
          <div className="mt-4 space-y-2">
            <div className="h-2 bg-slate-200 rounded w-11/12" />
            <div className="h-2 bg-slate-200 rounded w-full" />
            <div className="h-2 bg-slate-200 rounded w-9/12" />
            <div className="h-2 bg-slate-100 rounded w-10/12" />
          </div>
          <p className="mt-4 pt-2 border-t border-slate-200 text-[9px] text-slate-400">{brandName} · Notice of Non-Compliant Swimming Pool</p>
        </div>
      ) : (
        <div className="light-island rounded-lg border-2 border-slate-200 p-5 shadow-inner" data-testid="branding-preview-email">
          <div className="space-y-2 mb-5">
            <div className="h-2 bg-slate-200 rounded w-10/12" />
            <div className="h-2 bg-slate-200 rounded w-full" />
            <div className="h-2 bg-slate-100 rounded w-7/12" />
          </div>
          {/* signature block — mirrors org_signature_html */}
          <div className="pt-4" style={{ borderTop: "3px solid #14B8A6" }}>
            {custom && <img src={form.business_logo} alt="" className="max-h-[48px] max-w-[180px] object-contain mb-2.5 block" />}
            <p className="text-[12px] text-slate-600 mb-1.5">Best regards,</p>
            <p className="text-[14px] font-bold" style={{ color: "#1E1B4B" }}>{form.name || "Your Name"}</p>
            <p className="text-[12px] text-slate-500 leading-relaxed">
              {form.company_name && form.company_name !== form.name && <>{form.company_name}<br /></>}
              {form.abn && <>ABN {form.abn}<br /></>}
              {form.bdc_number && <>{String(form.bdc_number).toUpperCase().startsWith("BDC") ? form.bdc_number : `BDC ${form.bdc_number}`}<br /></>}
              {form.mobile && <>{form.mobile}<br /></>}
              {form.website && <span style={{ color: "#0D9488" }}>{String(form.website).replace(/^https?:\/\//, "")}<br /></span>}
              <span className="font-bold" style={{ color: "#0D9488" }}>{email}</span>
            </p>
          </div>
        </div>
      )}
      <p className="text-[11px] text-slate-400 mt-1.5">
        {custom
          ? "Updates live as you type — save to apply it to real documents and emails."
          : "No logo uploaded yet — notices currently use the standard platform letterhead. Upload your logo above to preview your own branding."}
      </p>
    </div>
  );
};

export default BrandingPreview;
